import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom'
import { LayoutDashboard, Server, Package, Radio, BarChart3, LogOut, User } from 'lucide-react'
import { useAuth } from '../contexts/AuthContext'

export default function Layout() {
  const location = useLocation()
  const navigate = useNavigate()
  const { user, logout } = useAuth()
  
  const navItems = [
    { path: '/dashboard', label: '仪表板', icon: LayoutDashboard },
    { path: '/devices', label: '设备管理', icon: Server },
    { path: '/versions', label: '版本管理', icon: Package },
    { path: '/gray-release', label: '灰度发布', icon: Radio },
    { path: '/stats', label: '统计分析', icon: BarChart3 }
  ]
  
  const handleLogout = () => {
    logout()
    navigate('/login')
  }
  
  return (
    <div className="min-h-screen bg-dark-bg">
      {/* 侧边栏 */}
      <aside className="fixed left-0 top-0 h-full w-64 bg-dark-card border-r border-dark-border">
        <div className="p-6">
          <h1 className="text-xl font-bold text-white">OTA 管理系统</h1>
          <p className="text-sm text-gray-400 mt-1">v0.4.0</p>
        </div>
        
        <nav className="mt-6">
          {navItems.map((item) => {
            const Icon = item.icon
            const isActive = location.pathname === item.path
            
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center gap-3 px-6 py-3 text-sm transition-colors ${
                  isActive
                    ? 'bg-primary-600/10 text-primary-400 border-r-2 border-primary-500'
                    : 'text-gray-400 hover:text-white hover:bg-dark-border'
                }`}
              >
                <Icon size={18} />
                {item.label}
              </Link>
            )
          })}
        </nav>
        
        {/* 用户信息 */}
        <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-dark-border bg-dark-card">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-8 h-8 rounded-full bg-primary-600 flex items-center justify-center">
              <User size={16} className="text-white" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-white truncate">{user?.username}</p>
              <p className="text-xs text-gray-400 capitalize">{user?.role}</p>
            </div>
          </div>
          <button
            onClick={handleLogout}
            className="w-full flex items-center justify-center gap-2 px-4 py-2 text-sm text-gray-400 hover:text-white hover:bg-dark-border rounded-lg transition-colors"
          >
            <LogOut size={16} />
            退出登录
          </button>
        </div>
      </aside>
      
      {/* 主内容区 */}
      <main className="ml-64">
        <header className="h-16 bg-dark-card border-b border-dark-border flex items-center justify-between px-6">
          <h2 className="text-lg font-semibold text-white">
            {navItems.find(item => item.path === location.pathname)?.label || '仪表板'}
          </h2>
          <div className="flex items-center gap-4">
            <span className="text-sm text-gray-400">
              {new Date().toLocaleDateString('zh-CN')}
            </span>
          </div>
        </header>
        
        <div className="p-6">
          <Outlet />
        </div>
      </main>
    </div>
  )
}
